module.exports = __webpack_public_path__ + "img/company.7b8f5147.jpg";